import { createSvgComponent } from "../../icon/createSvgComponent";
import AlignBack from "@core/__generated__/icon/figma/align-back.svg";
export default createSvgComponent(AlignBack);